module.exports = __webpack_public_path__ + "img/slider.9e74446a.jpg";